export const includesLowerCase = (source: string, searchText: string): boolean =>
    source.toLowerCase().includes(searchText.toLowerCase());
